import { Button, Picker, PickerItem, Text } from '@react-spectrum/s2';
import { style } from '@react-spectrum/s2/style' with { type: 'macro' };
import { useState } from 'react';

import type { FacebookPage } from '@/api/FacebookApi';

export const InstagramAccountSelect = ({
	pages,
	onConfirm,
	isSubmitting,
}: {
	pages: FacebookPage[];
	onConfirm: (pageId: string) => void;
	isSubmitting: boolean;
}) => {
	const [selectedPageId, setSelectedPageId] = useState<string | null>(null);

	const getPageLabel = (page: FacebookPage): string => {
		const igAccount = page.connected_instagram_account;
		if (igAccount) return `${page.name} (@${igAccount.username})`;
		return page.name;
	};

	return (
		<div className="flex flex-col gap-6">
			<Text
				styles={style({
					color: 'heading',
					fontSize: 'heading-lg',
					fontWeight: 'bold',
				})}
			>
				Select Instagram Account
			</Text>
			<Text
				styles={style({
					color: 'title',
					fontSize: 'title-xl',
				})}
			>
				Choose the Instagram account you want to connect:
			</Text>
			<Picker
				label="Instagram Account"
				value={selectedPageId}
				onChange={(value) => setSelectedPageId(value as string)}
			>
				{pages.map((page) => (
					<PickerItem key={page.id} id={page.id}>
						{getPageLabel(page)}
					</PickerItem>
				))}
			</Picker>
			<Button
				UNSAFE_className="mx-auto"
				variant="primary"
				onPress={() => selectedPageId && onConfirm(selectedPageId)}
				isDisabled={!selectedPageId || isSubmitting}
				isPending={isSubmitting}
			>
				<Text>Confirm Selection</Text>
			</Button>
		</div>
	);
};
